import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, MapPinIcon } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    country: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Carolina', 'Ana', 'Sofía', 'Valentina', 'Camila', 'Daniela'];
  const countries = ['Argentina', 'México', 'Colombia', 'Chile', 'Perú', 'Uruguay', 'Ecuador', 'España'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'recién'];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showRandomPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPopup = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCountry = countries[Math.floor(Math.random() * countries.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setCurrentBuyer({
      name: randomName,
      country: randomCountry,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (between 8 and 15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showRandomPopup, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-243">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      type: 'spring',
      bounce: 0.4
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-beige-sand p-4 max-w-sm flex items-start gap-4 cursor-pointer hover:bg-gray-50" onClick={() => window.open('https://cocinaproductiva.com/cart', '_blank')} data-id="element-244">
          <div className="bg-green-100 rounded-full p-2 flex-shrink-0 mt-1" data-id="element-245">
            <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-246" />
          </div>
          <div data-id="element-247">
            <p className="text-sm text-coffee-dark font-medium leading-snug" data-id="element-248">
              <span className="font-bold" data-id="element-249">{currentBuyer.name}</span> de{' '}
              {currentBuyer.country} acaba de comprar este libro digital.
            </p>
            <div className="flex items-center mt-1 text-xs text-taupe" data-id="element-250">
              <span className="text-green-600 font-semibold mr-2" data-id="element-251">
                Verificado
              </span>
              <span data-id="element-252">• {currentBuyer.time}</span>
            </div>
          </div>
          <button onClick={e => {
        e.stopPropagation();
        setIsVisible(false);
      }} className="absolute top-2 right-2 text-taupe-light hover:text-taupe" data-id="element-253">
            &times;
          </button>
        </motion.div>}
    </AnimatePresence>;
}